<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="12"
        md="12"
        sm="12"
      >
        <h2>{{ title }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*送付先コード"
          v-model="item.cd"
          :error-messages="validation_errors.cd"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="業種分類"
          :items=$store.getters.industryCodes
          item-text="label"
          item-value="id"
          v-model="item.industrycode"
          :error-messages="validation_errors.industrycode"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="検索用カナ"
          v-model="item.search_kana"
          :error-messages="validation_errors.search_kana"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*会社名または個人名"
          v-model="item.name1"
          :error-messages="validation_errors.name1"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="部署名"
          v-model="item.name2"
          :error-messages="validation_errors.name2"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="課名"
          v-model="item.name3"
          :error-messages="validation_errors.name3"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="名前"
          v-model="item.name4"
          :error-messages="validation_errors.name4"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="敬称"
          v-model="item.name_title"
          :error-messages="validation_errors.name_title"
          :items="$store.getters.nameTitles"
          item-text="name"
          item-value="id"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*郵便番号"
          prepend-inner-icon="mdi-magnify"
          v-model="item.zipcode"
          @change="searchAddress"
          :error-messages="validation_errors.zipcode"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="*都道府県"
          v-model="item.prefecture"
          :error-messages="validation_errors.prefecture"
          :items="$store.getters.prefectures"
          item-text="name"
          item-value="id"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="*住所1"
          v-model="item.address1"
          :error-messages="validation_errors.address1"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="住所2"
          v-model="item.address2"
          :error-messages="validation_errors.address2"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="電話番号"
          v-model="item.tel"
          :error-messages="validation_errors.tel"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="FAX"
          v-model="item.fax"
          :error-messages="validation_errors.fax"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="備考"
          v-model="item.note"
          :error-messages="validation_errors.note"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
        sm="6"
      >
        <v-switch
          label="送付を停止する"
          v-model="item.is_stopped"
          :error-messages="validation_errors.is_stopped"
        ></v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
        sm="8"
      >
        <v-text-field
          label="最終更新者"
          v-model="item.updated_by"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="最終更新日"
          v-model="item.updated_at"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col><v-btn class="red white--text" @click="save">保存する</v-btn></v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
        <v-subheader>この送付先が含まれる購読情報</v-subheader>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="subscriptions"
          :loading="loading"
          :options.sync="options"
          :footer-props="footer_props"
          disable-sort
          disable-filtering
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
        >
        <template v-slot:item.action="{ item }">
          <v-btn
            small
            color="default"
            :to="{ name: 'EditSubscription', params: {id: item.id}}"
          >
           購読情報 
          </v-btn>
        </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AddressSearch from '@/plugins/AddressSearch'
export default {
  data() {
    return {
      title: '',
      item: {'prefecture': null, 'address1': ''},
      validation_errors: {},
      headers: [
        {text: "購読コード", value: "cd"},
        {text: "顧客コード", value: "client_cd"},
        {text: "顧客名称", value: "name_combined"},
        {text: "商品", value: "product"},
        {text: "操作", value: "action", width: "130px"},
      ],
      subscriptions: [],
    }
  },
  created() {
    if (this.$attrs.isCreate) {
      this.title = "送付先新規登録"
    } else {
      this.title = "送付先編集"
      this.getItem();
      this.getSubscriptions();
    }
  },
  methods: {
    async getItem() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/masters/deliveryaddress/${this.$route.params.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            }
          }
        )
        this.item = response.data
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        this.$router.push({name: 'ClientList'}).catch(()=>{});
      }
    },
    async getSubscriptions() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/masters/deliveryaddress/${this.$route.params.id}/subscriptions`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            }
          }
        )
        console.log(response)
        this.subscriptions = response.data.subscriptions
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        this.$router.push({name: 'ClientList'}).catch(()=>{});
      }
    },
    async save() {
      if (this.$attrs.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    async searchAddress() {
      const address_data = await AddressSearch.getAddressFromZipcode(this.item.zipcode);
      if (address_data) {
        this.item.prefecture = address_data.prefcode;
        this.item.address1 = address_data.address;
      }
    },
    async create() {
      try {
        const response = await this.$axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/masters/deliveryaddress/`,
          this.item,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            }
          }
        )
        this.item = response.data;
        this.validation_errors = {};
        this.$store.dispatch('setSnackbar', {message: "登録されました", type: "success"});
        this.$router.push({'name': 'EditAddress', 'params': {id: this.item.id}});
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "登録できませんでした", type: "error"});
        this.validation_errors = error.response.data;
      }
    },
    async update() {
      try {
        const response = await this.$axios.put(
          `${process.env.VUE_APP_API_URL_BASE}/api/masters/deliveryaddress/${this.$route.params.id}/`,
          this.item,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            }
          }
        )
        this.item = response.data;
        this.validation_errors = {};
        this.$store.dispatch('setSnackbar', {message: "保存されました", type: "success"});
        this.getItem();
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "更新できませんでした", type: "error"});
        this.validation_errors = error.response.data;
      }
    },
  }
}
</script>